export default {
    mixed: {
        required: 'required',
        notType: 'incorrect',
    },
    number: {
        default: 'number',
        moreThan: 'mustBeMoreThan',
        min: 'mustBeMoreThan',
        max: 'mustBeLessThan',
        lessThan: 'mustBeLessThan',
        posititive: 'mustBePositive',
    },
    string: {
        email: 'email'
    }
};
